"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.versionOverrideGoerliMock = exports.versionDataGoerli = void 0;
const tools_1 = require("@axiom-crypto/tools");
const endpoints_1 = require("../endpoints");
exports.versionDataGoerli = {
    v2: {
        Addresses: {
            Axiom: "0x071b7aA74f060B40cB7EEE577c30E634276e7C9f",
            AxiomQuery: "0xBd5307B0Bf573E3F2864Af960167b24Aa346952b",
        },
        Urls: {
            ApiBaseUrl: "https://api.axiom.xyz/v2",
        },
        Endpoints: {
            GetBlockHashWitness: endpoints_1.Path.Block + endpoints_1.Endpoints.GetBlockHashWitness,
            GetBlockMerkleProof: endpoints_1.Path.Block + endpoints_1.Endpoints.GetBlockMerkleProof,
            GetBlockParams: endpoints_1.Path.Block + endpoints_1.Endpoints.GetBlockParams,
            GetBlockRlpHeader: endpoints_1.Path.Block + endpoints_1.Endpoints.GetBlockRlpHeader,
            GetBlockMmrProof: endpoints_1.Path.Block + endpoints_1.Endpoints.GetBlockMmrProof,
            GetAllQueries: endpoints_1.Path.Query + endpoints_1.Endpoints.GetAllQueries,
            GetDataForQuery: endpoints_1.Path.Query + endpoints_1.Endpoints.GetDataForQuery,
            GetQueryCount: endpoints_1.Path.Query + endpoints_1.Endpoints.GetQueryCount,
            GetQueryData: endpoints_1.Path.Query + endpoints_1.Endpoints.GetQueryData,
            GetQuery: endpoints_1.Path.Query + endpoints_1.Endpoints.GetQuery,
        },
        Values: {
            MaxQuerySize: tools_1.AxiomV2CircuitConstant.UserMaxSubqueries,
            QueryEncodingVersion: 2,
        },
    },
};
exports.versionOverrideGoerliMock = {
    v2: {
        Addresses: {
            Axiom: "0x2aE6ad6127C222f071C023086C442080B03AfCCe",
            AxiomQuery: "0xf15cc7B983749686Cd1eCca656C3D3E46407DC1f",
        },
    },
};
//# sourceMappingURL=goerli.js.map